import React, { createContext, type ReactNode, useContext } from 'react'
import preferenceKeys from '../person-page/preference-keys'
import type { ProviderValue } from './PreferenceProvider'
import PreferenceProvider from './PreferenceProvider'

const defaultSectionPreferences = {
  // Left column
  vitals: true,
  family: true,
  sources: true,
  'other-information': true,
  'non-vitals': true,
  lifesketch: true,
  'other-relationships': true,

  // Right column
  'research-help': true,
  'search-records': true,
  'mini-notes': true,
  'changelog-summary': true,
  tools: true,

  // Mobile views
  discussions: true,
  notes: true,
}

export type ExpandedSectionsOptions = Partial<typeof defaultSectionPreferences>
type ExpandedSectionsValue = ProviderValue<ExpandedSectionsOptions>

const ExpandedSectionsContext = createContext<ExpandedSectionsValue>([defaultSectionPreferences, () => undefined])

export function useExpandedSections(): ExpandedSectionsValue {
  return useContext(ExpandedSectionsContext)
}

type ToggleAllSectionsFunction = (prev: ExpandedSectionsOptions, newValue: boolean) => ExpandedSectionsOptions

export const toggleAllSections: ToggleAllSectionsFunction = (prev, newValue) => {
  return Object.keys(prev).reduce((acc, key) => {
    acc[key] = newValue
    return acc
  }, {}) as ExpandedSectionsOptions
}

type ExpandedSectionsProviderProps = {
  children: ReactNode
}

export default function ExpandedSectionsProvider({ children }: ExpandedSectionsProviderProps): JSX.Element {
  return (
    <PreferenceProvider
      preferenceKey={preferenceKeys.EXPANDED_DETAILS_SECTIONS}
      Context={ExpandedSectionsContext}
      defaultValue={defaultSectionPreferences}
    >
      {children}
    </PreferenceProvider>
  )
}
